/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для динамически создаваемых модальных окон.
   */
  app.DynamicPopupView = app.PopupView.extend({
    run: function (data) {
      var options = data || {};

      this.renderObj = {
        className: options.className,
        content: options.content
      };
      this.initiator = options.initiator;
      this.template = app.helpers.TemplateHelper.getTemplate('#dynamic-popup');

      this.render();
    },
    render: function () {
      var that = this;
      $('.popups').append(this.template(this.renderObj));
      this.setElement('.dynamic-popup');
      var bodyPosition = $('body').position(),
        initiator = that.initiator,
        initiatorOffset = initiator.offset(),
        initiatorLeftOffset = initiatorOffset ? initiatorOffset.left : 0,
        initiatorTopOffset = initiatorOffset ? initiatorOffset.top : 0,
        initiatorWidth = initiator.outerWidth(),
        initiatorHeight = initiator.innerHeight(),
        initiatorParentWidth = initiator.parent().outerWidth();

      // Инициализация и открытие popup'a
      var leftOffset = (initiatorLeftOffset - initiatorParentWidth / 2) + initiatorWidth / 2;
      var topOffset = initiatorTopOffset + initiatorHeight + 10;
      if (!app.isDesktop) {
        leftOffset = leftOffset - (bodyPosition ? bodyPosition.left : 0);
        topOffset = topOffset - (bodyPosition ? bodyPosition.top : 0);
      }
      this.initPopup(this.$el, null, {
        left: leftOffset,
        top: topOffset,
        width: initiatorParentWidth
      });
      this.popup.open();
      //Закрытие popup'а через 2,5 сек
      setTimeout(function () {
        that.remove();
      }, 2500);
    }
  });
})(jQuery);

}.call(window));